import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { SubscriptionSettingsComponent } from './gestione-offerta';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('usersettings.gestione-offerta', {
            url: '/gestione-offerta',
            views: {
                'userContent': {
                    template: '<gestione-offerta></gestione-offerta>'
                }
            },
            ncyBreadcrumb: {
                label: 'Gestione Offerta',
                parent: 'usersettings.index'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Gestione Offerta'
            }
        }
        );
};

stateConfig.$inject = ['$stateProvider'];

export const GestioneOffertaModule: string = ng
    .module('archiSmall.userSettings.gestioneOffertaModule', [
        'ui.bootstrap',
        uiRouter,
        'ncy-angular-breadcrumb'
    ])
    .component('gestioneOfferta', SubscriptionSettingsComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/gestione-offerta/gestione-offerta.module.ts